import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XIconComponent } from './x-icon.component';



@NgModule({
  declarations: [
    XIconComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    XIconComponent
  ]
})
export class XIconModule { }
